import { Box } from '@mui/material';
import {AnimatePresence, motion} from 'framer-motion';

const projects = [
    {
        name: "Operon",
        description: `A project management system for government institutions that helps manage workflows, improve transparency, and digitize project tracking across departments.`,
        link: "https://operon.ih-africa.com/"
    },
    {
        name: "Afroventure",
        description: `A tourism guide application designed to promote and explore travel destinations across Tanzania. It offers insights into cultural sites, natural attractions, and tourism services.`,
        link: "https://afroventure.ih-africa.com/"
    }
];

const Projects = () => {
    return (
        <Box sx={{ p: 3, color: 'white' }}>
            {projects.map((project, i) => (
                <AnimatePresence key={i}>
                    <motion.div
                        initial={{ opacity: 0, x: -20 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{ delay: i * 0.1, duration: 0.5 }}
                        className="timeline-card mb-4 p-4 rounded-4"
                        style={{
                            background: "rgba(255, 255, 255, 0.05)",
                            borderLeft: `4px solid #3b82f6`,
                            position: "relative",
                            backdropFilter: "blur(10px)"
                        }}
                    >
                        <div key={i} className="project-item mb-3">
                            <h5 className="text-white">
                                {project.link ? (
                                    <a
                                        href={project.link}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="text-decoration-none hover-underline"
                                        style={{ color: "#3b82f6" }}
                                    >
                                        {project.name}
                                    </a>
                                ) : (
                                    <span>{project.name}</span>
                                )}
                            </h5>
                            <p className="text-light" style={{ whiteSpace: "pre-line" }}>
                                {project.description}
                            </p>
                        </div>
                    </motion.div>
                </AnimatePresence>
            ))}
        </Box>
    );
};

export default Projects;